import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import FrTextInput from '../components/FrTextInput'
import FrSelect from '../components/FrSelect'
import FooterDelphus from '../components/FooterDelphus'
import { mCPF, mValidade } from '../utils/masks'
import Cards from 'react-credit-cards';
import { Icon } from 'react-icons-kit'
import {plus} from 'react-icons-kit/fa/plus'
import {cross} from 'react-icons-kit/icomoon/cross'
import 'react-credit-cards/es/styles-compiled.css';
import Dialog from '@material-ui/core/Dialog';
import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import api from '../services/api'
import { paramsToObject } from '../utils/functions'

import './styles/DefaultMainScreen.css';
import './styles/Manut.css';
import logo from '../imgs/logo-salute.png';
import { colors } from '../utils/vars'

const swal = withReactContent(Swal)

function CartoesPagamento(props) {
  const [data, setData] = useState({})
  const [cartao, setCartao] = useState({})
  const [comboCli, setComboCli] = useState([{ value: '', display: '' }])
  const [comboBan, setComboBan] = useState([{ value: '', display: '' }])
  const [showModal, setShowModal] = useState(false)
  const [cartoes, setCartoes] = useState([])
  const [padrao, setPadrao] = useState(0)
  const [restante, setRestante] = useState(0)
  const history = useHistory();

  useEffect(() => {
    const fetchData = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      let query = paramsToObject(urlParams)

      if (query.id > 0) {
        setComboBan(await api.getComboData('bandeira_cartao'))
        setComboCli(await api.getComboDataWhere('clientes', "?fk_cto=" + query.id))
        api.get('/contratos?pk_cto=' + query.id+'&adesao=S').then(r => {
          
          api.get('/contas_receber?pk_cto=' + query.id + '&frequencia_pagamento='+r.data[0].frequencia_pagamento).then(res => {
            setRestante(res.data[0].valorAdesao)
            setData({
              ...r.data[0], 
              valorAdesao: res.data[0].valorAdesao
            })
          })
        })

      }
    }
    fetchData()
  }, [])

  const handleChange = (e) => {
    const auxValues = { ...cartao };
    auxValues[e.target.name] = e.target.value;
    setCartao(auxValues);
  };

  const handleChangeValor = (e) => {
    let auxCartoes = [...cartoes]

    auxCartoes[e.target.name].valor = Number(e.target.value)

    setCartoes(auxCartoes)

    let pago = auxCartoes.reduce((accumulator, currentValue) => {
      return accumulator + Number(currentValue.valor)
    }, 0)
    setRestante(data.valorAdesao - pago)
  }

  async function handleSubmit(e) {
    e.preventDefault();
    if (cartoes.length == 0) {
      swal.fire({
        title: `<h2 style='color: ${colors.info900}'>Erro!</h2>`,
        text: "Obrigatório informar dados do cartão!",
        icon: 'warning',
      })
    } else if ((restante != 0)){
      swal.fire({
        title: `<h2 style='color: ${colors.info900}'>Erro!</h2>`,
        text: "Somatório do valor deve ser igual ao valor total da adesão!",
        icon: 'warning',
      })
    } 
    else {
      const urlParams = new URLSearchParams(window.location.search);
      let query = paramsToObject(urlParams)

      let ctrs = await api.get('contas_receber?pk_cto='+query.id)
      let parcelas = ctrs.data.reduce((accumulator, currentValue) => accumulator + String(currentValue.pk_ctr) + ',', 0)   
      
      if (parcelas.toString().indexOf(',') > 0){
        parcelas = parcelas.slice(0, -1)
      }

      const auxValues = {
        cartoes: [...cartoes],
        pk_cli: data.fk_cli,
        parcelas: parcelas
      };

      api.post('/contratos/cartao', cartoes[padrao])
      api.post('pagarMe/cartoes?fk_cli='+ data.fk_cli, auxValues).then(r => {
        swal.fire({
          title: `<h2 style='color: ${colors.info900}'>Pagamento realizado!<h2>`,
          html: `<p style='color: ${colors.info900}'>Seu cadastro já foi atualizado.</p>`,
          icon: 'success',
        }).then((result) => {
          if (result.value) {
            window.history.back()
          }
        })
      })
    }
  }

  function confirmaCartao() {
    if ((!cartao.cvc) || (!cartao.expiry) || (!cartao.number) || (!cartao.name) || (!cartao.cpf_titular_cartao)) {
      return swal.fire({
        title: `<h2 style='color: ${colors.info900}'>Erro!</h2>`,
        text: "Obrigatório informar nome do titular, cpf, número, validade e cvc do cartão!",
        icon: 'warning',
      })
    } 
    let auxCartoes = [...cartoes]
    let auxCartao = {...cartao}
    auxCartao.valor = 0
    auxCartoes.push(auxCartao)
    setCartoes(auxCartoes)
    setShowModal(false)
  }

  function incluiCartao() {
    setShowModal(true)
  }

  function escondeModal() {
    setShowModal(false)
  }

  const handleInputFocus = (e) => {
    const auxValues = { ...data };
    auxValues.focus = e.target.name;
    setData(auxValues);
  }

  function handleChangePadrao(e) {
    setPadrao(e.target.name)
  }

  function removerCartao(e) {
    e.preventDefault()

    let auxCartoes = [...cartoes]
    auxCartoes.splice(e.target.name, 1)

    setCartoes(auxCartoes)
  }


  return (

    <div className="cartao" style={{height: '100vh'}}>
      <img alt="logo" src={logo} title="salute" className="cartao_logo" />

      <div className="Manut">
       
        <div className="ManutContent">
          <div className="defaultHeader" >
            <h3 style={{borderRadius: 6}}>Pagamento Adesão</h3>
          </div>
          <div style={{minWidth: 450}}>
            {cartoes.map((item, index) => {
              return (
                <div 
                  key={item.number} 
                  style={{display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 8, marginTop: 12}}
                >
                  <button 
                    name={index}
                    onClick={removerCartao}
                    style={{border: 'none'}}
                  >
                    <Icon icon={cross} size={18} style={{color:'#083c7c'}} />
                  </button>
                  <div className='cartaoDiv'>
                    {item.number}
                  </div>  
                    <FormControlLabel 
                      style={{margin: 0,  alignItems: 'center', display: 'flex', width: 120}}
                      control={
                        <Checkbox 
                          style={{ padding: '1px', color: '#083c7c' }}
                          checked={padrao==index}
                          name={index}
                          onChange={handleChangePadrao}
                          inputProps={{ 'aria-label': 'select all desserts' }}
                        />} 
                      label={padrao==index ? "Cartão Padrao" : ''} 
                    />
                    <FrTextInput 
                      value={cartoes[index].valor || ''}
                      style={{ width: 75, margin: 0 }}
                      name={index}
                      id={index}
                      color="#333333"
                      label="Valor"
                      variant="outlined"
                      size="small"
                      onChange={handleChangeValor}
                      maxLength={100}
                      autoFocus
                      onFocus={handleInputFocus}
                    />
                </div>
              )
            })}
          </div>
          <br />
          <button 
            className="btnIncluirCartao"
            onClick={incluiCartao}
          >
            <Icon icon={plus} size={24} style={{color:'#083c7c'}} />
            Incluir Cartao
          </button>
          {data ? `Total Adesão: ${new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(data.valorAdesao || 0)}` : ''}
          <br/>
          {`Total Restante: ${new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(restante || 0)}`}
  
          {/* <FooterDelphus /> */}
          <div className="regButtons">
            <button onClick={handleSubmit}>Pagar</button>
          </div>
        </div>
        <div>
          <Dialog aria-labelledby="simple-dialog-title" open={showModal} fullWidth={true} maxWidth={'lg'}>
            <div className="defaultHeader">
              <h3>{'Cadastro de Cartões'}</h3>
            </div>
              <div className="cartao" >
                <Cards
                  cvc={cartao.cvc || ''}
                  expiry={cartao.expiry || ''}
                  focused={cartao.focus}
                  name={cartao.name || ''}
                  number={cartao.number || ''}
                />

                <form id="searchForm" onSubmit={confirmaCartao}>
                  <div style={{marginTop: 16}}>
                    <FrSelect
                      value={data.fk_cli || ''}
                      name="fk_cli"
                      id="fk_cli"
                      label='Nome do Cliente'
                      data={comboCli}
                      style={{ width: 425 }}
                      disabled
                    />

                    <br />
                    <FrTextInput
                      value={cartao.name || ''}
                      style={{ width: 425 }}
                      name="name"
                      id="name"
                      color="#333333"
                      label="Nome Titular Cartão"
                      variant="outlined"
                      size="small"
                      onChange={handleChange}
                      maxLength={100}
                      autoFocus
                      onFocus={handleInputFocus}
                    />


                    <br />
                    <FrTextInput
                      value={mCPF(cartao.cpf_titular_cartao) || ''}
                      style={{ width: 150 }}
                      name="cpf_titular_cartao"
                      id="cpf_titular_cartao"
                      color="#333333"
                      label="CPF Titular Cartão"
                      variant="outlined"
                      size="small"
                      onChange={handleChange}
                      maxLength={20}
                    />
                    <br />
                    <FrSelect
                      value={cartao.fk_ban || ''}
                      name="fk_ban"
                      id="fk_ban"
                      label='Bandeira do Cartão'
                      data={comboBan}
                      style={{ width: 300 }}
                      onChange={handleChange}
                    />
                    <br />
                    <FrTextInput
                      value={cartao.number || ''}
                      style={{ width: 155 }}
                      name="number"
                      id="number"
                      color="#333333"
                      label="Nº Cartão"
                      variant="outlined"
                      size="small"
                      onChange={handleChange}
                      maxLength={20}
                      onFocus={handleInputFocus}
                    />
                    <br />
                    <FrTextInput
                      value={mValidade(cartao.expiry) || ''}
                      style={{ width: 140 }}
                      name="expiry"
                      id="expiry"
                      color="#333333"
                      label="Validade (mês/ano)"
                      variant="outlined"
                      size="small"
                      onChange={handleChange}
                      maxLength={7}
                      onFocus={handleInputFocus}
                    />

                    <FrTextInput
                      value={cartao.cvc || ''}
                      style={{ width: 70 }}
                      name="cvc"
                      id="cvc"
                      color="#333333"
                      label="CVC"
                      variant="outlined"
                      size="small"
                      onChange={handleChange}
                      maxLength={3}
                      onFocus={handleInputFocus}
                    />
                    <br />
                    <FrTextInput
                      value={cartao.dia_venc || ''}
                      style={{ width: 80 }}
                      name="dia_venc"
                      id="dia_venc"
                      color="#333333"
                      label="Dia Venc."
                      variant="outlined"
                      size="small"
                      onChange={handleChange}
                      maxLength={2}
                    />
                    <label>Dia do mês que vence a fatura do cartão de crédito</label>
                  </div>
                </form>
              
            </div>



            <div className="FrModalFooter">
              <div className="FrModalButtonsDiv" style={{margin: 0, paddingInline: 16}}>

                <button onClick={confirmaCartao}> Incluir</button>
                <button onClick={escondeModal}> Sair </button>
              </div>
            </div>
          </Dialog>
        </div>  
      </div>
    </div>
  );
}

export default CartoesPagamento;